import { ShiftsPlanningVersionFragment } from 'generated/resources/graphql'
import first from 'lodash/first'
import orderBy from 'lodash/orderBy'
import type { Moment } from 'moment'

import PlanningVersion, {
  PlanningVersionPayload,
} from 'modules/shift_management/store/internal/models/PlanningVersion'
import { PLANNING_TOOL } from 'modules/time_planning/store/models/PlanningVersion'

class PlanningVersions {
  planningVersions: PlanningVersion[]

  constructor(planningVersions: PlanningVersion[]) {
    this.planningVersions = planningVersions
  }

  /**
   * Transforms an array of objects from a request into an array of Leave
   * objects
   */
  /**
   * @deprecated Before using this method, consider using the `buildFromGraphQL` hook since
   * we are trying to move away from using mobx-rest and use GraphQL instead.
   */
  static buildFromProps(planningVersions: PlanningVersionPayload[]): PlanningVersions {
    const defaultPlanningVersion = new PlanningVersion({
      id: 0,
      default: true,
      planning_tool: PLANNING_TOOL.contractHours,
      effective_at: '01/01/1970',
    })

    // FIXME: revisit the plannigVersion type
    const planningVersionsObjects = planningVersions.map(
      (planningVersion) => new PlanningVersion(planningVersion as any)
    )

    return new PlanningVersions([defaultPlanningVersion].concat(planningVersionsObjects))
  }

  static buildFromGraphQL(planningVersions: ShiftsPlanningVersionFragment[]): PlanningVersions {
    const defaultPlanningVersion = new PlanningVersion({
      id: 0,
      default: true,
      planning_tool: PLANNING_TOOL.contractHours,
      effective_at: '01/01/1970',
    })

    // FIXME: revisit the plannigVersion type
    const planningVersionsObjects = planningVersions.map((pv) =>
      PlanningVersion.buildFromGraphQL(pv)
    )

    return new PlanningVersions([defaultPlanningVersion].concat(planningVersionsObjects))
  }

  isAfterThanNextPlanningVersion(models: PlanningVersion[], index: number, date: Moment) {
    return (
      // last one
      models[index + 1]?.effectiveAt.isAfter(date, 'day') || index === models.length - 1
    )
  }

  isBeforeThanDate(model: PlanningVersion, date: Moment) {
    return model.effectiveAt.isSameOrBefore(date, 'day')
  }

  currentPlanningVersionWithinDate(models: PlanningVersion[], date: Moment) {
    const currentPlanningVersion = models.find(
      (model: PlanningVersion, index: number) =>
        this.isBeforeThanDate(model, date) &&
        this.isAfterThanNextPlanningVersion(models, index, date)
    )

    return currentPlanningVersion || first(models)
  }

  planningVersionWithinDate(date: Moment): PlanningVersion | undefined {
    return this.currentPlanningVersionWithinDate(
      orderBy(this.planningVersions, (pv: PlanningVersion) => pv.effectiveAt, 'asc'),
      date
    )
  }

  filterByPlanningTool(planningTool: string): PlanningVersion[] {
    return this.planningVersions.filter((pv: PlanningVersion) => pv.planningTool === planningTool)
  }
}

export default PlanningVersions
